module.exports = __webpack_public_path__ + "assets/img/7.2698eb48.png";